import React from 'react'
import { useTheme } from 'styled-components'

import { IconComponent } from '@application/Interfaces/Icons/types'
import { Theme } from '@application/Interfaces/Themes/ThemeType'

export const FacebookIcon: IconComponent = ({ className, colorCode = 'p500', width = 15, height = 28 }) => {
    const theme = useTheme() as Theme
    const color = theme.color[colorCode]

    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 15 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.4351 0.945071L10.8373 0.939453C6.7953 0.939453 4.18317 3.54752 4.18317 7.58419V10.6479H0.565722C0.253132 10.6479 0 10.8945 0 11.1987V15.6376C0 15.9418 0.25342 16.1881 0.565722 16.1881H4.18317V27.3889C4.18317 27.6931 4.4363 27.9395 4.74889 27.9395H9.46863C9.78122 27.9395 10.0343 27.6928 10.0343 27.3889V16.1881H14.264C14.5766 16.1881 14.8297 15.9418 14.8297 15.6376L14.8314 11.1987C14.8314 11.0526 14.7717 10.9127 14.6658 10.8094C14.5598 10.706 14.4155 10.6479 14.2654 10.6479H10.0343V8.05075C10.0343 6.80247 10.34 6.16878 12.0109 6.16878L14.4346 6.16794C14.7469 6.16794 15 5.92132 15 5.6174V1.49562C15 1.19197 14.7472 0.945633 14.4351 0.945071Z"
                fill={color}
            />
        </svg>
    )
}
